import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyRovoAgentsForYou: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RovoAgentsForYou" */ './RovoAgentsForYou.tsx'))
			.RovoAgentsForYou,
});
